var map = {
	"./AIS Jugend service.png": 758,
	"./caritas.png": 864,
	"./inpust.png": 352,
	"./jugend am.png": 492,
	"./lebens.png": 2,
	"./sos.png": 12,
	"./soziale dienste.png": 624,
	"./tg.png": 846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 164;